import { Logger } from 'aws-amplify';
import { DataStore } from '@aws-amplify/datastore';
import { Predicates } from '@aws-amplify/datastore/lib-esm/predicates';

import { Setting as Model } from '.';
import { DataStoreOperation } from '../types';

export type Key = string;

export type Value = string;

export type Setting =
  | {
      readonly key: Key;
      value: Value;
    }
  | Model;

export type Settings = {
  [key: string]: Value;
};

const logger = new Logger('Settings', 'DEBUG');

export async function query(key?: Key) {
  logger.info(`to query ${key || 'all settings'}`);
  try {
    const items = await DataStore.query(
      Model,
      key ? (c) => c.key('eq', key) : Predicates.ALL
    );
    logger.info(`queried ${JSON.stringify(items, null, 2)}`);

    return items;
  } catch (error) {
    logger.error(`failed to query: ${error}`);
    throw error;
  }
}

export async function createOrUpdate(setting: Setting) {
  try {
    const queried = await DataStore.query(Model, (c) =>
      c.key('eq', setting.key)
    );

    let result;
    if (queried.length > 0) {
      result = await DataStore.save(
        Model.copyOf(queried[0], (updated) => {
          // eslint-disable-next-line no-param-reassign
          updated.value = setting.value;
        })
      );
      logger.debug(`updated ${JSON.stringify(result)}`);
    } else {
      result = await DataStore.save(
        new Model({
          key: setting.key,
          value: setting.value
        })
      );
      logger.debug(`created ${JSON.stringify(result)}`);
    }

    return result;
  } catch (error) {
    logger.error(`createOrUpdate failed: ${error}`);
    throw error;
  }
}

export async function subscribe(
  operation: DataStoreOperation,
  f: (setting: Setting) => void
) {
  try {
    const subscription = DataStore.observe(Model).subscribe((msg) => {
      if (msg.opType && msg.opType === operation) f(msg.element);
    });

    return subscription;
  } catch (error) {
    logger.error(`subscribe failed: ${error}`);
    throw error;
  }
}
